import { makeStyles } from "@material-ui/core";

import colors from "../../../constants/colors";

const useStyles = makeStyles((theme) => ({
  headerCell: {
    display: "flex",
  },
  iconLabel: {
    "font-weight": "bold",
    "font-size": "12px",
    "font-family": "Montserrat",
    marginLeft: "4%",
  },
  delete: {
    color: colors.carmine,
  },
  iconLabelRed: {
    "font-weight": "bold",
    "font-size": "12px",
    "font-family": "Montserrat",
    marginLeft: "4%",
    color: colors.carmine,
  },
  cell: {
    "font-weight": "bold",
    "font-size": "15px",
    "font-family": "Montserrat",
  },
  buttonCell: {
    display: "flex",
    alignItems: "center",
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

export default useStyles;
